import styled from 'styled-components'

const FullContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-evenly;
    align-items: space-evenly;
`

export default FullContainer